import axios from '@/plugins/axios'
import store from '@/store'
import Vue from 'vue'

const login = async function (variables) {
  try {
    const use2fa = {
      use_2fa: false,
      email: null
    }

    const response = await axios.post('login', variables)
    const { data } = response

    // If use 2fa in login, dont save access_token
    if (typeof data === 'object' && data.use_2fa) {
      use2fa.use_2fa = true
      use2fa.email = data.email

      return use2fa
    }

    onLogin(data.access_token)
    return use2fa
  } catch (error) {
    return Promise.reject(error)
  }
}

const register = async variables => {
  try {
    const response = await axios.post('register', variables)
    const { data } = response
    onLogin(data.access_token)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const logout = async () => {
  try {
    await axios.post('logout')
    onLogout()
    return true
  } catch (error) {
    return Promise.reject(error)
  }
}

const sendResetPasswordEmail = async email => {
  try {
    const response = await axios.post('password/email', {
      email: email
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

// eslint-disable-next-line camelcase
const sendResetPassword = async ({ token, email, password, password_confirmation }) => {
  try {
    const params = {
      token,
      email,
      password,
      password_confirmation
    }
    const response = await axios.post('password/reset', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const onLogout = () => {
  Vue.cookie.delete('access_token')
  store.dispatch('auth/setAuthenticated', { authenticated: false }, { root: true })
}

const onLogin = function (token) {
  Vue.cookie.set('access_token', token, { expires: '1Y' })
  store.dispatch('auth/setAuthenticated', { authenticated: true }, { root: true })
}

// 2FA
const validateCode2fa = async ({ code, email }) => {
  try {
    const params = {
      code,
      email
    }

    const response = await axios.post('two-factor-authentication/authenticate', params)
    const { data } = response
    onLogin(data.access_token)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const reSendCode2fa = async ({ email }) => {
  try {
    const params = {
      email: email
    }
    const response = await axios.post('two-factor-authentication/solicit', params)
    const { data } = response

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  login,
  register,
  sendResetPassword,
  sendResetPasswordEmail,
  onLogin,
  onLogout,
  logout,
  validateCode2fa,
  reSendCode2fa
}
